"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var makeError = require("make-error");
var util_1 = require("util");
/**
 * @internal
 */
exports.SEPARATOR_TEXT = "\n\nThe following exception was the direct cause of the above exception:\n\n";
var BaseError = /** @class */ (function (_super) {
    __extends(BaseError, _super);
    function BaseError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    BaseError.prototype[util_1.inspect.custom || 'inspect'] = function () {
        return fullStack(this);
    };
    return BaseError;
}(makeError.BaseError));
exports.BaseError = BaseError;
function fullStack(error) {
    var err = error.cause;
    var fullStack = error.stack;
    while (err) {
        fullStack += exports.SEPARATOR_TEXT;
        fullStack += err.stack || err.message;
        err = err.cause;
    }
    return fullStack;
}
exports.fullStack = fullStack;
//# sourceMappingURL=index.js.map